import { StarFill } from "@gravity-ui/icons";
import { Card, Flex, Icon, User, Text } from "@gravity-ui/uikit";

import { Review } from "../types/review.ts";
import css from "./ReviewCard.module.scss";

const Stars = () => {
  return (
    <div className={css.star}>
      {Array.from("x".repeat(5)).map((_v, i) => (
        <Icon data={StarFill} key={`star_${i}`} />
      ))}
    </div>
  );
};
export const ReviewCard = ({ review }: { review: Review }) => {
  return (
    <Card className={css.card} view="clear">
      <Flex direction="column" gap="3">
        <User
          avatar={{ text: `${review.name}`, theme: "normal" }}
          name={review.name}
          description={review.description}
          size="l"
        />
        <Stars />
        <Text ellipsisLines={3} ellipsis>
          {review.text}
        </Text>
      </Flex>
    </Card>
  );
};
